"use client";

export default function About() {
  return (
    <div className="grid grid-rows-[20px_1fr_20px] items-center justify-items-center min-h-screen p-8 pb-20 sm:p-20">
      <div className="flex flex-col gap-8 row-start-2 items-center sm:items-start">
        <h1 className="scroll-m-20 text-4xl font-extrabold tracking-tight lg:text-5xl orange">
          About Us
        </h1>
        <h2 className="scroll-m-20 border-b pb-2 text-3xl font-semibold tracking-tight first:mt-0">
          How we formed
        </h2>
        <p className="leading-7 not-first:mt-6">
          The founders of Cerberus Stomping Grounds or CSG community have been
          playing the ARMA games together since early 2014. We met on the
          Definitive Gaming and Stalk & Strike ARMA 2 wasteland servers, and
          developed our team coordination further through the popular mod of
          DayZ, then Epoch and eventually Overpoch.
        </p>
        <p className="leading-7 not-first:mt-6">
          ARMA 3 was soon added to the mix, and we have been through many
          communities and game types ever since. Everything from Altis Life to
          Exile to Milsim, we&apos;ve done it at some point. We&apos;ve all
          partaken in varying communities and responsibilities within those
          communities, and have gained a very well rounded knowledge of the
          functionality of ARMA 3 and what it takes to be a part of and run a
          successful community.
        </p>
        <p className="leading-7 not-first:mt-6">
          We are a dedicated group of skilled players that have decided to put
          our experience and deep knowledge of the game that we love into a
          server we hope you will enjoy.
        </p>
        <h2 className="scroll-m-20 border-b pb-2 text-3xl font-semibold tracking-tight first:mt-0">
          Servers we played on
        </h2>
        <p className="leading-7 not-first:mt-6">
          Over the years of ARMA, we played on many different game modes created
          by an even larger list of communities, below is a list of all
          servers/communities we have been involved in and/or have played on
          extensively:
        </p>
        <h3 className="scroll-m-20 text-2xl font-semibold tracking-tight">
          ARMA 2 Communities:
        </h3>
        <ul className="list-disc">
          <li>DefG Wasteland</li>
          <li>Stalk & Strike Wasteland</li>
          <li>OP4 Wasteland</li>
          <li>FFAAA Milsim</li>
          <li>EVoG DayZ Epoch</li>
          <li>TLC DayZ Overpoch</li>
          <li>Firecock DayZ Overpoch</li>
          <li>DNG DayZ Overpoch</li>
          <li>UK111 DayZ Overpoch</li>
        </ul>
        <h3 className="scroll-m-20 text-2xl font-semibold tracking-tight">
          ARMA 3 Communities:
        </h3>
        <ul className="list-disc">
          <li>DMM Patrol Ops</li>
          <li>Spearhead Exile/ Milsim</li>
          <li>TAC BF Milsim</li>
          <li>STS Altis Life</li>
          <li>ADK Exile</li>
          <li>EXP Exile</li>
          <li>Spartan Gaming Exile</li>
          <li>Karlus Bojangles Exile</li>
        </ul>
        <h3 className="scroll-m-20 text-2xl font-semibold tracking-tight">
          DayZ Standalone Communities:
        </h3>
        <ul className="list-disc">
          <li>ADK DayZ</li>
          <li>TW</li>
          <li>DAYZ Usonia</li>
          <li>MTAS Playground</li>
        </ul>
        <h2 className="scroll-m-20 border-b pb-2 text-3xl font-semibold tracking-tight first:mt-0">
          Staff Team
        </h2>
        <h3 className="scroll-m-20 text-2xl font-semibold tracking-tight">
          Head Admins:
        </h3>
        <ul className="list-disc">
          <li>Bubba</li>
          <li>Jstrow</li>
          <li>Spartan</li>
          <li>Danny Dorito</li>
        </ul>
        <h3 className="scroll-m-20 text-2xl font-semibold tracking-tight">
          Community Manager:
        </h3>
        <ul className="list-disc">
          <li>iiBetrayforAR</li>
        </ul>
      </div>
    </div>
  );
}
